"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantUsingVariantOptions = exports.getVariantMaximumOrderQuantity = exports.getVariantMinimumOrderQuantity = exports.getVariantStatus = exports.getVariantListingPrice = exports.getVariantImages = exports.getVariantMarketPlaceLinks = exports.getVariantThumbImage = exports.getVariantTitle = exports.getVariantPosition = exports.getVariantPrice = void 0;
const getVariantPrice = (allVariants, groups) => {
    const variant = (0, exports.getVariantUsingVariantOptions)(allVariants, groups);
    return variant === null || variant === void 0 ? void 0 : variant.price;
};
exports.getVariantPrice = getVariantPrice;
const getVariantPosition = (allVariants, groups) => {
    const variant = (0, exports.getVariantUsingVariantOptions)(allVariants, groups);
    return variant === null || variant === void 0 ? void 0 : variant.position;
};
exports.getVariantPosition = getVariantPosition;
const getVariantTitle = (allVariants, groups) => {
    const variant = (0, exports.getVariantUsingVariantOptions)(allVariants, groups);
    return variant === null || variant === void 0 ? void 0 : variant.title;
};
exports.getVariantTitle = getVariantTitle;
const getVariantThumbImage = (allVariants, groups) => {
    const variant = (0, exports.getVariantUsingVariantOptions)(allVariants, groups);
    return variant === null || variant === void 0 ? void 0 : variant.thumbImage;
};
exports.getVariantThumbImage = getVariantThumbImage;
const getVariantMarketPlaceLinks = (allVariants, groups) => {
    const variant = (0, exports.getVariantUsingVariantOptions)(allVariants, groups);
    return variant === null || variant === void 0 ? void 0 : variant.marketPlaceLinks;
};
exports.getVariantMarketPlaceLinks = getVariantMarketPlaceLinks;
const getVariantImages = (allVariants, groups) => {
    const variant = (0, exports.getVariantUsingVariantOptions)(allVariants, groups);
    return variant === null || variant === void 0 ? void 0 : variant.images;
};
exports.getVariantImages = getVariantImages;
const getVariantListingPrice = (allVariants, groups) => {
    const variant = (0, exports.getVariantUsingVariantOptions)(allVariants, groups);
    return variant === null || variant === void 0 ? void 0 : variant.listingPrice;
};
exports.getVariantListingPrice = getVariantListingPrice;
const getVariantStatus = (allVariants, groups) => {
    const variant = (0, exports.getVariantUsingVariantOptions)(allVariants, groups);
    return variant === null || variant === void 0 ? void 0 : variant.status;
};
exports.getVariantStatus = getVariantStatus;
const getVariantMinimumOrderQuantity = (allVariants, groups) => {
    const variant = (0, exports.getVariantUsingVariantOptions)(allVariants, groups);
    return variant === null || variant === void 0 ? void 0 : variant.minimumOrderQuantity;
};
exports.getVariantMinimumOrderQuantity = getVariantMinimumOrderQuantity;
const getVariantMaximumOrderQuantity = (allVariants, groups) => {
    const variant = (0, exports.getVariantUsingVariantOptions)(allVariants, groups);
    return variant === null || variant === void 0 ? void 0 : variant.maximumOrderQuantity;
};
exports.getVariantMaximumOrderQuantity = getVariantMaximumOrderQuantity;
const getVariantUsingVariantOptions = (allVariants, productVariantGroup) => {
    const productVariantOptionIds = productVariantGroup.map((g, idx) => {
        const variantOption = g.variantOptions.find((o) => o.selected);
        if (idx === productVariantGroup.length - 1) {
            return {
                variantGroupId: g.id,
                variantGroupOptionId: g.variantOptions[0].id,
            };
        }
        return {
            variantGroupId: g.id,
            variantGroupOptionId: variantOption === null || variantOption === void 0 ? void 0 : variantOption.id,
        };
    });
    return allVariants.find((v) => v.productVariantOptionIds.every((x) => productVariantOptionIds.some((g) => g.variantGroupId === x.variantGroupId &&
        g.variantGroupOptionId === x.variantGroupOptionId)));
};
exports.getVariantUsingVariantOptions = getVariantUsingVariantOptions;
